import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJson } from '@hcr/api/shared'

import type { HoldingNotVisibleDto, ProblemDetailsDto } from '../../dtos'
import { HoldingNotVisibleDtoSchema } from '../../dtos/responses'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

export const createHoldingsNotVisibleQueryKey = () => ['consumer', 'holdings-not-visible']

export const createHoldingsNotVisibleQuery =
  (baseUrl: string) =>
  <Data = HoldingNotVisibleDto>(
    params: AuthorizedRequestParams,
    options?: Partial<UseQueryOptions<HoldingNotVisibleDto, ProblemDetailsDto, Data>>
  ) =>
    useQuery<HoldingNotVisibleDto, ProblemDetailsDto, Data>({
      ...options,
      queryKey: createHoldingsNotVisibleQueryKey(),
      queryFn: () =>
        getJson({
          headers: createAuthorizationHeader(params.idToken),
          schema: HoldingNotVisibleDtoSchema,
          url: `${baseUrl}/owners/holdings-not-visible`,
        }),
    })
